import { Box, Button, SvgIcon, TableCell, TableRow } from '@mui/material';
import { format } from 'date-fns';
import de from 'date-fns/locale/de';
import { useTranslation } from 'react-i18next';

import { palette } from '../../assets/styles/themes/tokens';
import { subscriptionDateFormat } from '../../constants';
import { currencyFormat } from '../../utils/format';
import getMuiIcon from '../../utils/getMuiIcon';

interface InvoiceTableRowProps {
	invoice: {
		id: string;
		invoiceDate: string;
		invoiceNumber: string;
		amount: number;
		status: string;
	};
	onClickDownload: (invoiceId: string) => void;
}

const InvoiceTableRow = ({ invoice, onClickDownload }: InvoiceTableRowProps) => {
	const { t } = useTranslation();

	const formatInvoiceDate = (invoiceDate: string) => {
		try {
			return format(new Date(invoiceDate), subscriptionDateFormat, {
				locale: de,
			});
		} catch {
			return '';
		}
	};

	return (
		<TableRow>
			<TableCell color={palette.text.secondary}>{formatInvoiceDate(invoice.invoiceDate)}</TableCell>
			<TableCell color={palette.text.secondary}>{invoice.invoiceNumber}</TableCell>
			<TableCell color={palette.text.secondary}>{currencyFormat(invoice.amount)}</TableCell>
			<TableCell color={palette.text.secondary}>{t(invoice.status)}</TableCell>
			<TableCell align="right">
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'flex-end',
						alignItems: 'center',
					}}
				>
					<Button
						data-testid={`invoice-download-button-${invoice.id}`}
						color="inherit"
						sx={{
							minWidth: 0,
							padding: 0,
							width: 24,
							height: 24,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
						onClick={() => onClickDownload(invoice.id)}
					>
						<SvgIcon
							component={getMuiIcon('importIcon')}
							viewBox="0 0 20 20"
							sx={{
								marginLeft: 'auto',
								marginRight: 0,
							}}
						/>
					</Button>
				</Box>
			</TableCell>
		</TableRow>
	);
};

export default InvoiceTableRow;
